<template>
	<el-dropdown :class="['language-switch', `language-switch--${theme}`]" popper-class="language-switch-menu" @command="switchLocale">
		<span class="el-dropdown-link language-switch-text">
			{{ currentLocaleLabel }}<i class="el-icon-arrow-down el-icon--right"></i>
		</span>
		<el-dropdown-menu slot="dropdown">
			<el-dropdown-item
				v-for="language in languageOptions"
				:key="language.value"
				:command="language.value"
				class="language-option"
			>
				<a href="javascript:void(0)" class="language-change" :title="language.description">{{ language.label }}</a>
			</el-dropdown-item>
		</el-dropdown-menu>
	</el-dropdown>
</template>

<script>
	import { languageOptions, setLocale } from '../../i18n';

	export default {
		name: 'language-switcher',
		props: {
			theme: {
				type: String,
				default: 'light',
			},
		},
		data() {
			return {
				languageOptions,
			};
		},
		computed: {
			currentLocaleLabel() {
				const currentLanguage = this.languageOptions.find(language => language.value === this.$i18n.locale);
				return currentLanguage ? currentLanguage.label : languageOptions[0].label;
			},
		},
		methods: {
			switchLocale(locale) {
				if (locale === this.$i18n.locale) return;
				setLocale(locale, true);
				// 刷新当前页可使其按新语言重新生成。
				window.location.reload();
			},
		},
	};
</script>

<style>
	.language-switch-menu {
		max-height: 360px;
		overflow-y: auto;
	}

	.language-switch-menu .el-dropdown-menu__item.language-option:hover {
		background-color: #409eff !important;
		color: #fff !important;
	}

	.language-switch-menu .language-change {
		display: block;
		color: inherit;
		text-decoration: none;
	}

	.language-switch--dark .language-switch-text {
		color: #fff;
	}

	.language-switch--light .language-switch-text {
		color: #333;
		font-size: 13px;
		cursor: pointer;
	}
</style>
